<template>
  <v-container
    fluid
    class="grey lighten-4 fill-height"
  >
    <v-layout align-top>
      <v-flex
        xs12
        sm12
        md12
        lg8
        ma-5
      >
        <v-card
          max-width="95%"
          class="mx-auto"
        >
          <v-list subheader>
            <v-subheader>Emails</v-subheader>

            <v-list-item
              @click="noop()"
              dense
              v-for="(item, ix) in recent"
              :key="ix"
            >
              <!--         <v-list-item-avatar>
          <v-img src="https://cdn.dribbble.com/users/722835/avatars/normal/2aa863d0913f94812e4c74867836e3af.jpg?1573346454"></v-img>
        </v-list-item-avatar>
 -->
              <v-list-item-icon>
                <v-icon small>article</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title v-text="item.attributes.note" />
              </v-list-item-content>

              <v-list-item-action>        
                <v-list-item-icon>
                  <v-icon
                    @click="noop()"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    delete
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>        
              <v-list-item-action>        
                <v-list-item-icon>
                  <v-icon
                    @click="showEdit(item.id)"
                    :color="item.link ? 'deep-blue accent-4' : 'grey'"
                  >
                    mdi-wrench
                  </v-icon>
                </v-list-item-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  name: 'Emails',
  components: {
  },
  computed: {
    recent() {
      return this.$store.state.included;
    }
  },    
  data: () => ({
    chatbots: [
      {name: 'newsletters@mindsink.0studio.net', link: 'https://telegram.com/cbot-1701'},
      {name: 'legacy-email@agh.edu.pl', link: 'https://telegram.com/cbot-1701'},
    ]
  }),
  methods : {
    showEdit(itemID) {
      console.log('  - click showEditForm [emails]')
      console.log(`    itemID: ${itemID}`)
      this.$store.dispatch('ui/showEditForm', itemID)
      // this.editVisible = true;
      // console.log(this.$refs.preview);
      // this.$refs.preview.focus();
    },
    noop: () => {
      return;
    }
  }
};
</script>


<style scoped>
</style>
